import React, { forwardRef } from "react";
import { ModalOrBottomSheetWrapperProps } from "./ModalOrBottomSheetWrapper.types";
import Modal from "../Modal/Modal";
import useMediaQuery from "../../hooks/useMediaQuery";
import { useMobileSheetViewportLock } from "../../hooks/useMobileSheetViewportLock";
import BottomSheet from "../BottomSheet";
import FullViewportBottomSheet from "../FullViewportBottomSheet";

const ModalOrBottomSheetWrapper = forwardRef<
    HTMLDivElement,
    ModalOrBottomSheetWrapperProps
>((props: ModalOrBottomSheetWrapperProps, ref) => {
    const {
        id,
        children,
        fullScreenSheet,
        isOpen,
        onToggle,
        renderFooter,
        renderTitle,
        showCloseIcon,
        showHeader,
        titleText,
        paddedModal,
        modalSeparationGap,
        blurBackground,
        fullScreenModal,
        modalShouldCloseOnOverlayClick,
        modalShouldCloseOnEsc,
    } = props;

    const { modalBodyHeight, modalSize, modalBodyMinHeight } = props;
    const {
        sheetBodyHeight,
        sheetBodyMinHeight,
        sheetBodyMaxHeight,
        sheetMarginTop,
        sheetPaddingBottom,
        sheetOverflowHeight,
        paddedSheet,
        disableSheetOverlayClick,
        disableSheetSwipe,
        sheetBackgroundColor,
        borderRadius,
        sheetBorderRadius,
        sheetTitleTextSize,
        showBottomSheetOverlay,
        hideSheetBodyScrollbar,
        hideModalBodyScrollbar,
        disableSheetZoom,
        viewportSheet,
        bodyStyle,
    } = props;

    const mobileScreen = useMediaQuery({ queryType: "mobile" });

    useMobileSheetViewportLock({
        isOpen: Boolean(isOpen),
        freezeOnMobile: mobileScreen,
        disableZoom: disableSheetZoom,
    });

    if (isOpen) {
        return (
            <>
                {mobileScreen ? (
                    viewportSheet ? (
                        <FullViewportBottomSheet
                            id={id}
                            isOpen={isOpen}
                            renderFooter={renderFooter}
                            renderTitle={renderTitle}
                            titleText={titleText}
                            onToggle={onToggle}
                            showCloseIcon={showCloseIcon}
                            showHeader={showHeader}
                            paddingBottom={sheetPaddingBottom}
                            padded={paddedSheet}
                            backgroundColor={sheetBackgroundColor}
                            borderRadius={sheetBorderRadius}
                            titleTextSize={sheetTitleTextSize}
                            showBottomSheetOverlay={showBottomSheetOverlay}
                            hideBodyScrollbar={hideSheetBodyScrollbar}
                            blurBackground={blurBackground}
                            disableOverlayClick={disableSheetOverlayClick}
                            bodyStyle={bodyStyle}
                        >
                            {children}
                        </FullViewportBottomSheet>
                    ) : (
                        <BottomSheet
                            bodyHeight={sheetBodyHeight}
                            fullScreen={fullScreenSheet}
                            isOpen={isOpen}
                            id={id}
                            marginTop={sheetMarginTop}
                            overflowHeight={sheetOverflowHeight}
                            renderFooter={renderFooter}
                            renderTitle={renderTitle}
                            titleText={titleText}
                            onToggle={onToggle}
                            showCloseIcon={showCloseIcon}
                            bodyMinHeight={sheetBodyMinHeight}
                            bodyMaxHeight={sheetBodyMaxHeight}
                            showHeader={showHeader}
                            paddingBottom={sheetPaddingBottom}
                            padded={paddedSheet}
                            disableOverlayClick={disableSheetOverlayClick}
                            disableSwipe={disableSheetSwipe}
                            backgroundColor={sheetBackgroundColor}
                            borderRadius={sheetBorderRadius}
                            titleTextSize={sheetTitleTextSize}
                            showBottomSheetOverlay={showBottomSheetOverlay}
                            hideBodyScrollbar={hideSheetBodyScrollbar}
                            blurBackground={blurBackground}
                            disableSheetZoom={disableSheetZoom}
                            bodyStyle={bodyStyle}
                        >
                            {children}
                        </BottomSheet>
                    )
                ) : (
                    <Modal
                        bodyHeight={modalBodyHeight}
                        bodyMinHeight={modalBodyMinHeight}
                        size={modalSize}
                        onToggle={onToggle}
                        showCloseIcon={showCloseIcon}
                        isOpen={isOpen}
                        id={id}
                        renderFooter={renderFooter}
                        renderTitle={renderTitle}
                        titleText={titleText}
                        showHeader={showHeader}
                        padded={paddedModal}
                        modalSeparationGap={modalSeparationGap}
                        blurBackground={blurBackground}
                        borderRadius={borderRadius}
                        fullScreenModal={fullScreenModal}
                        shouldCloseOnOverlayClick={
                            modalShouldCloseOnOverlayClick
                        }
                        shouldCloseOnEsc={modalShouldCloseOnEsc}
                        hideBodyScrollbar={hideModalBodyScrollbar}
                        bodyStyle={bodyStyle}
                    >
                        {children}
                    </Modal>
                )}
            </>
        );
    } else {
        return <></>;
    }
});

export default ModalOrBottomSheetWrapper;
